import type {TransactionalMessageBanner as TransactionalMessageBannerType} from '@github-ui/code-view-types'

import {TransactionalMessageBanner} from './TransactionalMessageBanner'

export interface TransactionalMessageBannersProps {
  banners: TransactionalMessageBannerType[]
  rounded?: boolean
}

// Stable key per banner: the backend emits at most one banner per nudge and sets
// `analytics.category` to the nudge id, so it uniquely identifies a banner in the
// list. The index is folded in as a defensive tie-breaker.
function getBannerKey(banner: TransactionalMessageBannerType, index: number): string {
  return `${banner.analytics.category}-${index}`
}

/**
 * Renders a list of transactional message banners, one `TransactionalMessageBanner`
 * per entry. This is the render path for the coordinator-driven (v2) payload, where
 * several cap-exempt transactional banners can win for the same surface; the legacy
 * payload renders a single `TransactionalMessageBanner` directly.
 */
export function TransactionalMessageBanners({banners, rounded}: TransactionalMessageBannersProps) {
  if (banners.length === 0) {
    return null
  }

  return (
    <>
      {banners.map((banner, index) => (
        <TransactionalMessageBanner key={getBannerKey(banner, index)} banner={banner} rounded={rounded} />
      ))}
    </>
  )
}
